import React, { useCallback, useRef, useContext, useState } from 'react';
import { FiLock, FiMail } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { useAuth } from '../../contexts/auth';
import { useToast } from '../../contexts/toast';
import getValidationErrors from '../../utils/getValidationErrors';
import { ThemeContext } from 'styled-components';
import Input from '../../components/Input';
import SigninButton from '../../components/SigninButton';
import { Container } from './styles';
import { URI } from '../../contracts/enums'
import logo_black from '../../assets/icons/logo_black.svg';


interface SignInFormData {
  username: string;
  password: string;
}

const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();

  const { colors } = useContext(ThemeContext);
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      try {
        setButtonDisabled(true)
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          username: Yup.string().required('Username is required.'),
          password: Yup.string().required('Password is required.'),
        });

        await schema.validate(data, { abortEarly: false });
        await signIn({ username: data.username, password: data.password });

        history.push(URI.dashboard);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Log in error',
          description: 'Check your credentials and try again.',
        });
      }
      finally {
        setButtonDisabled(false)
      }
    },
    [addToast, history, signIn],
  );

  return (
    <Container>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <img alt="Logo" src={logo_black}></img>

        <Input name="username" icon={FiMail} placeholder="Username" />

        <Input
          name="password"
          icon={FiLock}
          type="password"
          placeholder="Password"
        />

        <div className='button-wrapper'>
          <SigninButton disabled={buttonDisabled} _bgColor={colors.primary} _hoverColor={colors.primary} _textColor={colors.white} type="submit">Acessar</SigninButton>
        </div>
      </Form>
    </Container>
  );
};

export default SignIn;